module.exports = __webpack_public_path__ + "img/camel-comb1-3.93f7c5b8.jpg";